import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';

/** 确认弹窗内的变更明细列表 */
export default function TemplateChangeDiffList({
  intro = '以下字段与模板库最新版本不一致，重新加载将覆盖对应区域（其它区域保留）：',
  changes = [],
  emptyText = '未解析到字段级差异。重新加载仍会用最新模板覆盖该区域。',
}) {
  const rows = Array.isArray(changes) ? changes : [];
  if (!rows.length) {
    return <p className="temu-confirm__message">{emptyText}</p>;
  }
  return (
    <div className="temu-confirm__diff">
      <p className="temu-confirm__message">{intro}</p>
      <ul className="temu-confirm__diff-list">
        {rows.slice(0, 40).map((row) => (
          <li key={row.id || row.label} className="temu-confirm__diff-item">
            <div className="temu-confirm__diff-label">{row.label}</div>
            <div className="temu-confirm__diff-values">
              <span className="temu-confirm__diff-before" title={row.before}>
                <em>{fixedUi("当前")}</em>
                {row.before}
              </span>
              <span className="temu-confirm__diff-arrow" aria-hidden="true">→</span>
              <span className="temu-confirm__diff-after" title={row.after}>
                <em>{fixedUi("最新")}</em>
                {row.after}
              </span>
            </div>
          </li>
        ))}
      </ul>
      {rows.length > 40 ? (
        <p className="temu-confirm__diff-more">…其余 {rows.length - 40} 项</p>
      ) : null}
    </div>
  );
}
